import React, { useEffect, useState } from 'react'
import AppointmentListItem from './AppointmentListItem'
import { PatientStore } from '../../stores'
import {
  APPOINTMENT_TYPE,
  BOOKING_STATUS,
  VISIT_TYPE,
  LIST_TYPE,
  NETWORK_STATUS
} from '../../Constants'
import {
  Grid,
  Checkbox,
  FormGroup,
  TextField,
  makeStyles,
  FormControl,
  FormControlLabel
} from '@material-ui/core'
import { FaSearch } from 'react-icons/fa'
import Loading from 'react-loading'
import NoRecordImg from '../../images/noRecordFound.png'
// import Pagination from '@material-ui/lab/Pagination'
import useDebounce from '../../customHooks/useDebounce'

export default function UpcomingAppointments() {
  const [searchKeyWord, setSearchKeyWord] = React.useState('')
  const [currentPage, setCurrentPage] = React.useState(1)
  const [pageCount, setPageCount] = React.useState(1)
  const debouncedSearchTerm = useDebounce(searchKeyWord, 1000)

  const { upcomingdata, networkStatus, totalPagesCount } =
    PatientStore.useStoreState(state => ({
      ...state.appointments
    }))
  const { getList } = PatientStore.useStoreActions(actions => ({
    ...actions.appointments
  }))

  //start filter code
  const [filter, setFilter] = React.useState({
    all: true,
    Tele: false,
    In_Person: false
  })
  const [filter2, setFilter2] = React.useState({
    confirmed: false,
    checked_in: false
  })

  const classess = useStyless()

  useEffect(() => {
    getAppointmentList()
  }, [filter, filter2, debouncedSearchTerm, currentPage])

  useEffect(() => {
    setPageCount(totalPagesCount)
  }, [totalPagesCount])

  const onPaginationClick = (event, value) => {
    setCurrentPage(value)
  }

  const handleChange = e => {
    let value = e.target.checked
    if (!value && e.target.name === 'all') {
      return
    } else if (!value) {
      setFilter({
        all: true,
        Tele: false,
        In_Person: false
      })
    } else {
      onPaginationClick('', 1)
      let newFilter = filter
      Object.keys(filter).map(key => {
        newFilter[key] = false
      })
      setFilter({ ...newFilter, [e.target.name]: e.target.checked })
    }
  }

  const handleChange2 = e => {
    let value = e.target.checked
    if (!value) {
      setFilter2({
        confirmed: false,
        checked_in: false
      })
    } else {
      onPaginationClick('', 1)
      let newFilter = filter2
      Object.keys(filter2).map(key => {
        newFilter[key] = false
      })
      setFilter2({ ...newFilter, [e.target.name]: e.target.checked })
    }
  }

  const getAppointmentList = () => {
    let filterResult = Object.keys(filter).find(key => filter[key] === true)
    let filter2Result = Object.keys(filter2).find(key => filter2[key] === true)
    let filterValue = Object.keys(APPOINTMENT_TYPE).find(
      key => APPOINTMENT_TYPE[key].label === filterResult
    )
    let filter2Value = Object.keys(BOOKING_STATUS).find(
      key => BOOKING_STATUS[key].label === filter2Result
    )
    if (filterValue || filter2Value) {
      let status = filter2Value ? BOOKING_STATUS[filter2Value].value : '0'
      let appointment_type = filterValue
        ? APPOINTMENT_TYPE[filterValue].id
        : '0'
      getList({
        list_type: LIST_TYPE.UPCOMING.label,
        status: status,
        visit_type: VISIT_TYPE.ALL.id,
        appointment_type: appointment_type,
        currentPage: currentPage,
        searchString: searchKeyWord,
        sorting: {
          appointment_date: 'ASC',
          start_time: 'ASC'
        }
      })
    }
  }

  const onTextChange = e => {
    setSearchKeyWord(e.target.value)
  }

  return (
    <div>
      <div className={classess.checkboxes}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4} className={classess.checkboxcol}>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value="all"
                  control={
                    <Checkbox
                      color="primary"
                      onChange={handleChange}
                      name="all"
                    />
                  }
                  label="all"
                  labelPlacement="end"
                  checked={filter.all}
                />
                <FormControlLabel
                  value="In_Person"
                  control={
                    <Checkbox
                      color="primary"
                      onChange={handleChange}
                      name="In_Person"
                    />
                  }
                  label="In-Person"
                  labelPlacement="end"
                  checked={filter.In_Person}
                />
                <FormControlLabel
                  value="Tele"
                  control={
                    <Checkbox
                      color="primary"
                      onChange={handleChange}
                      name="Tele"
                    />
                  }
                  label="Tele"
                  labelPlacement="end"
                  checked={filter.Tele}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            style={{
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
              flexDirection: 'column'
            }}>
            <FormControl
              component="fieldset"
              className={classess.SearchCol}
              style={{ width: '92%' }}>
              <FormGroup
                aria-label="position"
                row
                className={classess.SearchRow}>
                <FormControlLabel
                  className={classess.SearchRow2}
                  control={
                    <TextField
                      className={classess.inputElement}
                      onChange={onTextChange}
                      label="Search"
                      value={searchKeyWord}
                    />
                  }
                />
                <FormControlLabel
                  className={classess.SearchBtn}
                  control={<FaSearch />}
                />
              </FormGroup>
            </FormControl>
            <FormControl component="fieldset" style={{ width: '100%' }}>
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value="confirmed"
                  control={
                    <Checkbox
                      color="primary"
                      onChange={handleChange2}
                      name="confirmed"
                    />
                  }
                  label="Confirmed"
                  labelPlacement="end"
                  checked={filter2.confirmed}
                />
                <FormControlLabel
                  value="checked_in"
                  control={
                    <Checkbox
                      color="primary"
                      onChange={handleChange2}
                      name="checked_in"
                    />
                  }
                  label="Checked In"
                  labelPlacement="end"
                  checked={filter2.checked_in}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </div>
      {networkStatus === NETWORK_STATUS.FETCHING ? (
        <Loading
          type="bubbles"
          textAlign="center"
          color="#9138aa"
          height={50}
        />
      ) : upcomingdata.length !== 0 ? (
        <>
          {upcomingdata.map((appointment, index) => {
            return (
              <AppointmentListItem
                appointment={appointment}
                isForFollowupBooking={false}
              />
            )
          })}
        </>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <img
              alt="No data"
              style={{ display: 'block', width: '200px' }}
              src={NoRecordImg}
            />
          </div>
        </>
      )}
      {/* <Pagination
        count={pageCount}
        shape="rounded"
        onChange={onPaginationClick}
      /> */}
    </div>
  )
}
const useStyless = makeStyles(() => ({
  checkboxes: {
    marginTop: '15px',
    '& label > span': {
      fontSize: '14px'
    },
    '& span > svg': {
      width: '0.8em',
      height: '0.8em'
    }
  },
  SearchRow2: {
    width: '100%'
  },
  formcol: {
    '@media (max-width:767px)': {
      margin: '0px !important'
    }
  },
  SearchBtn: {
    position: 'absolute',
    top: '18px',
    right: '0px'
  },
  Searchcol: {
    width: '100% !important',
    '@media (max-width:767px)': {
      marginBottom: '15px'
    }
  },
  SearchRow: {
    width: '100%'
  },
  Rightcheckbox: {
    '@media (max-width:767px)': {
      textAlign: 'left !important'
    }
  },
  inputElement: {
    width: '100%',
    borderWidth: 1,
    fontSize: '14px',
    '& .MuiInput-input': {
      paddingRight: '30px'
    },
    '&>div': {
      '&::before': {
        borderWidth: '1px'
      }
    }
  }
}))
